/*
* @Author: gujianghua
* @Date:   2020-02-20 16:31:21
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-02-21 13:52:36
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'
export default {
	// 保存邀请榜表单
	saveInviteForm(data) {
	    return service({
			url: '/cloud/course/v1/admin/live/invite/chart/save',
			method: 'post',
			data
		})
	},
    // 榜单列表
	getInviteRankList(params) {
	    return service({
			url: '/cloud/course/v1/admin/live/invite/chart/pages',
			method: 'get',
			params
		})
	},
    // 榜单删除
	delInvite(id) {
	    return service({
			url: '/cloud/course/v1/admin/live/invite/chart/delete?id='+id,
			method: 'post',
			
		})
	},
    // 榜单详情
	getInviteDetail(params) {
	    return service({
			url: '/cloud/course/v1/admin/live/invite/chart/detail',
			method: 'get',
			params
		})
	},
    // 用户列表
	getUserList(params) {
	    return service({
			url: '/cloud/course/v1/admin/live/invite/chart/userPages',
			method: 'get',
			params
		})
	},
	exportExcel(params) {		
		return service({
			url: '/cloud/course/v1/admin/live/invite/chart/exportExcel',
			method: 'get',
			params,
			responseType: 'blob'
		})
	}
}


// WEBPACK FOOTER //
// ./src/api/operateManage/shareRank.js